import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "reducers";
import { IChatMessage } from "./domain/IChatMessage";
import { chatService } from "./services/chat.service";

export const deleteMessage = createAsyncThunk(
  "Chat/deleteMessage",
  async (messageId: number) => {
    try {
      return await chatService.deleteMessage(messageId);
    } catch (err) {
      setError(err);
    }
  }
);

interface chatState {
  loading: boolean;
  messages: IChatMessage[];
  deleteMessageModalOpen: boolean;
  messageForDeletion: number;
  error: any;
}

const initialState: chatState = {
  loading: false,
  messages: [],
  deleteMessageModalOpen: false,
  messageForDeletion: -1,
  error: null,
};

export const chatSlice = createSlice({
  name: "chat",
  initialState: initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setDeleteMessageModalOpen: (
      state,
      action: PayloadAction<{ visible: boolean; index: number }>
    ) => {
      state.deleteMessageModalOpen = action.payload.visible;
      state.messageForDeletion = action.payload.index;
    },
    addNewMessage: (state, action: PayloadAction<IChatMessage>) => {
      if (action.payload)
        state.messages = [action.payload, ...state.messages];
    },
    setMessage: (state, action: PayloadAction<any>) => {
      if (action.payload) {
        state.messages = state.messages.map((message) =>
          message.message.messageId === action.payload.messageId
            ? {
              ...message,
              message: { ...message.message, ...action.payload },
            }
            : message
        );
      }
    },
    deleteMessageById: (state, action: PayloadAction<number>) => {
      if (action.payload) {
        state.messages = state.messages.filter(
          (message) => message.message.messageId !== action.payload
        );
      }
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
});

export const selectState = (state: RootState) => state.chat;
export const selectMessageForDeletion = (state: RootState) =>
  state.chat.messages[state.chat.messageForDeletion];

export const {
  setLoading,
  setDeleteMessageModalOpen,
  addNewMessage,
  setMessage,
  deleteMessageById,
  setError,
} = chatSlice.actions;

export default chatSlice.reducer;
